import React from "react";
import { Seo } from "../components/Seo";
import { FromTheBookletSpecimen } from "../components/FromTheBookletSpecimen";

const FromTheBooklet = () => {
  return (
    <div data-testid="from-the-booklet-page" className="pt-16 md:pt-20">
      <Seo
        title="From the Booklet · A Final Tribute Specimen · The Raven's Quill"
        description="How a Final Tribute reads: a specimen obituary written for an invented man, set as it would appear in the funeral booklet."
        path="/from-the-booklet"
      />
      <h1 className="sr-only">From the Booklet: A Final Tribute Specimen</h1>
      <FromTheBookletSpecimen standalone />
    </div>
  );
};

export default FromTheBooklet;
